import { render, staticRenderFns } from "./lab-order-lot-operate.vue?vue&type=template&id=51f6f7cd&"
import script from "./lab-order-lot-operate.vue?vue&type=script&lang=js&"
export * from "./lab-order-lot-operate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports